<template>
  <div>
    <div class="card">
      <b-table
        :class="checkTable(typeOfTable)"
        ref="selectableTable"
        selected-variant="active"
        :items="tableProperties.items"
        :fields="tableProperties.fields"
        @row-selected="getSelectedRow"
        :no-border-collapse="noCollapse"
        responsive="sm"
        striped
        sticky-header="200px"
        head-variant="#6192b1"
        :style="typeOfTable =='summaryTable' ? 'max-height:1000px; overflow:auto; margin-bottom:0px !important' :'max-height:300px; overflow:auto; margin-bottom:0px !important'"
        :filter="filter"
        :busy="tableLoading"
        show-empty
        empty-text="No Records Found"
      >
        <template v-slot:cell(typeOfRegistration)="row" class="table-action"  >
          <span :class="gstStatus(row.item.statusCode)" class="mr-1"></span>
          <span>{{row.item.typeOfRegistration}}</span>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(cost)="row">
          <span>{{row.item.cost}} [{{getCurrency(row.item.jobNativeCurrency)}}]</span>
        </template>
        <template v-slot:cell(toggle_icon)="row" class="table-action">
          <!-- {{row}} -->
          <div class="p-0 m-0 row">
            <!-- <span @click="row.toggleDetails" v-if="!row.detailsShowing" style="cursor:pointer;"> -->
            <img
              @click="row.toggleDetails"
              v-if="!row.detailsShowing"
              class="table-img cursor-pointer"
              src="@/assets/UpButton.svg"
            />
            <img
              @click="row.toggleDetails"
              v-if="row.detailsShowing"
              class="table-img cursor-pointer"
              src="@/assets/DownButton.svg"
            />
            <img
              @click="triggerEditModal(row.item)"
              class="edit-icon ml-2 cursor-pointer"
              v-if="typeOfTable == 'gstTable' && (row.item.statusCode == 1 || row.item.statusCode == 2 ||
              row.item.statusCode == 7)"
              src="@/assets/edit-icon.svg"
            />
            <!--img
              @click="deleteGSTDetail(row.item)"
              class="edit-icon ml-2 cursor-pointer"
              v-if="typeOfTable == 'gstTable' && (row.item.statusCode == 7 || row.item.statusCode == 2
              || row.item.statusCode == 3)"
              src="@/assets/delete_Icon.svg"
            /-->
            <!-- <img
              @click="triggerTrackingModal(row.item)"
              class="edit-track-icon ml-1 cursor-pointer table-img"
              v-if="typeOfTable == 'gstTable' && row.item.statusCode != 7"
              src="@/assets/bluetrack.png"
            /> -->
            <!-- </span> -->
          </div>
        </template>

        <template slot="gstGstEffectiveDate" slot-scope="row">
          <!-- <span>{{calculateDays(row.item.gstGstEffectiveDate)}}</span> -->
          <span>{{row.item.gstGstEffectiveDate}}</span>
        </template>

        
        <template v-slot:cell(gstDocumentId)="row">
          <span><a v-if="row.item.gstDocumentId!=null"
                  @click="showFile(row.item.gstDocumentId)"
                  href="#"
                >{{getAttachmentName(row.item.gstDocumentId)}}</a>
                <span v-if="row.item.gstDocumentId==null">-</span>
          </span>
        </template>
        
        <template slot="remarks" slot-scope="row">
          <!-- <span>{{calculateDays(row.item.gstGstEffectiveDate)}}</span> -->
          <span>{{row.item.remarks ? row.item.remarks : '-'}}</span>
        </template>

        <template slot="row-details" slot-scope="row">
          <div style="width:35%" class="ml-5" v-if="typeOfTable =='summaryTable'">
            <div class="po-inline-table">
              <table class="table table-striped">
                <thead>
                  <tr class="table-bg">
                    <th class="table-bg text-left" style="width:20%" scope="col">{{jobtype}} Number</th>
                    <th class="table-bg text-left" style="width:10%" scope="col">{{jobtype}} Value</th>
                    <!-- <th class="table-bg text-left" style="width:15%" scope="col">Rag Status</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(inlineDetails,i) in row.item.subTable.items" :key="i">
                    <td
                      class="table-body-cell text-left po-information cursor-pointer"
                      @click="goToPoWoDetails(inlineDetails.poNumber)"
                    >{{inlineDetails.poNumber}}</td>
                    <!-- <td class="table-body-cell text-left w-10">{{inlineDetails.poValue}}</td> -->
                    <td class="table-body-cell text-left">
                      <span
                        style="cursor:pointer"
                        v-if="inlineDetails.nativeValue"
                        v-b-tooltip.hover.left="`[${inlineDetails.nativeCurrency}] ${inlineDetails.nativeValue}`"
                      >{{inlineDetails.poValue}}</span>
                      <span v-else>{{inlineDetails.poValue}}</span>
                    </td>
                    <!-- <td class="table-body-cell text-left pl-4 ml-2 w-10">
                      <span :class="getStatusClass(row.item.ragStatus)"></span>
                    </td>-->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="width:80%" class="ml-5">
            <div
              class="po-inline-table"
              v-if="(typeOfTable =='gstTable' || typeOfTable =='gstTableSummary' || typeOfTable == 'ApprovedgstTable')"
            >
              <table
                class="table table-striped gst-table"
                v-if="row.item.secondLevel.registrationNumber != null"
              >
                <thead>
                  <tr class="table-bg">
                    <th class="table-bg text-left" scope="col">Orgin Country</th>
                    <th class="table-bg text-left" scope="col">Origin State</th>
                    <th class="table-bg text-left" scope="col">Work State</th>
                    <th class="table-bg text-left" scope="col">Registration Date</th>
                    <th class="table-bg text-left" scope="col">Registration Number</th>
                    <th class="table-bg text-left" scope="col">Effective Period</th>
                    <!-- <th class="table-bg text-left" style="width:15%" scope="col">PO Value</th>
                    <th class="table-bg text-left" style="width:15%" scope="col">Rag Status</th>-->
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      class="table-body-cell text-left w-10"
                    >{{row.item.secondLevel.originCountry}}</td>

                    <td class="table-body-cell text-left w-10">{{row.item.secondLevel.originState}}</td>
                    <td class="table-body-cell text-left w-10">{{row.item.secondLevel.workState}}</td>
                    <td
                      class="table-body-cell text-left w-10"
                    >{{row.item.secondLevel.registrationDate}}</td>
                    <td
                      class="table-body-cell text-left w-10"
                    >{{row.item.secondLevel.registrationNumber}}</td>
                    <td
                      class="table-body-cell text-left w-10"
                    >{{row.item.secondLevel.effectiveDate}}</td>
                  </tr>
                </tbody>
              </table>
              <table
                class="table table-striped gst-table"
                v-if="row.item.typeOfRegistration == 'Vertical Registration'"
              >
                <thead>
                  <tr class="table-bg">
                    <th class="table-bg text-left" scope="col">Business category</th>
                    <th class="table-bg text-left" scope="col">Business sub-category</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="table-body-cell text-left w-10">{{row.item.categoryCode}}</td>

                    <td class="table-body-cell text-left w-10">{{row.item.subCategoryCode}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { PartnerService } from "../services/partnerService";
import { SummaryServices } from "../services/summaryService";
const SummaryService = new SummaryServices();
const partnerService = new PartnerService();
export default {
  props: [
    "tableProperties",
    "filter",
    "tableLoading",
    "typeOfTable",
    "jobtype"
  ],
  data() {
    return {
      dialog: false,
      currentCurrency: ""
    };
  },
  methods: {
    
    getAttachmentName(documentId) {
      if (documentId) {
        let attachmentName = "";
        attachmentName = documentId.split(/_(.+)/)[1]
          ? documentId.split(/_(.+)/)[1]
          : documentId;
        return attachmentName;
      }
    },
    showFile(event) {
      this.loading = true;
      SummaryService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    },
    getSelectedRow(index) {
      console.log(index);
    },
    getCurrency(currency) {
      if (currency) {
        this.currentCurrency = currency;
        return this.currentCurrency;
      }
    },
    goToPoWoDetails(value) {
      var details = {
        poNumber: value,
        currency: this.currentCurrency
      };
      this.$emit("getPoNumber", details);
    },
    closePop() {
      this.dialog = false;
    },
    gstStatus(status) {
      if (status == 4) {
        return "yellow-dot";
      } else if (status == 2) {
        return "blue-dot";
      } else if (status == 3) {
        return "red-dot";
      } else if (status == 7) {
        return "orange-dot";
      }
    },
    getStatusClass(status) {
      switch (status) {
        case "0":
          return "red-dot";
          break;
        case "1":
          return "green-dot";
          break;
        default:
          return "green-dot";
          break;
      }
    },
    checkTable(value) {
      if (value == "gstTable" || value == "ApprovedgstTable") {
        return "gst-table";
      }
    },
    triggerEditModal(value) {
      this.$emit("openGstModal", value);
    },
    deleteGSTDetail(gstObj){

    },
    // triggerTrackingModal(value) {
    //   this.$emit("openTrackingModal", value);
    // },
    calculateDays(date) {
      var dates = date.split(",");
      var firstDate = dates[0];
      var second = dates[1];
      var calculateDate = firstDate + `to` + firstDate;

      return calculateDate;
    }
  }
};
</script>
<style>
.edit-icon {
  /* width: 20px !important; */
  max-height: 13px;
}
.edit-track-icon {
  /* width: 20px !important; */
  max-height: 17px;
}
.table-img {
  /* width: 20px !important; */
  max-height: 17px;
}
.thClass {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
.thClassCenter {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
.thClassLeft {
  background-color: #6192b1;
  color: white;
  text-align: left !important;
}
.thClassRight {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
}
.table-heading-text {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
}
.table td {
  font-family: Arial;
}
.table-bg {
  font-size: 14px;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  color: #ffffff !important;
  background-color: #6192b1 !important;
  border-color: #6192b1 !important;
  text-align: center;
  margin-right: 5% !important;
}
/* .v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: relative;
  overflow-y: auto;
  top: 142px;
  left: 249px;
} */
.po-inline-table thead th {
  color: #fff;
  position: sticky;
  top: 0;
}
.gst-table {
  font-size: 12px !important;
}
</style>
<style scoped>
/* .table-body-cell {
  text-align: left;
} */
.po-information:hover {
  text-decoration: underline;
  color: #002d72 !important;
  font-weight: bold;
}
.po-inline-table {
  max-height: 300px;
  overflow: auto;
  border-radius: 4px !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16) !important;
  background-color: #ffffff;
  -webkit-box-shadow: none !important;
}
.orange-dot {
  height: 10px;
  width: 10px;
  background-color: orange;
  border-radius: 50%;
  display: inline-block;
}
.red-dot {
  height: 10px;
  width: 10px;
  background-color: #f43b3b;
  border-radius: 50%;
  display: inline-block;
}
.yellow-dot {
  height: 10px;
  width: 10px;
  background-color: #f4cf08;
  border-radius: 50%;
  display: inline-block;
}
.blue-dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #002d72;
}
.green-dot {
  height: 10px;
  width: 10px;
  background-color: #62a94b;
  border-radius: 50%;
  display: inline-block;
}
.arrow-down {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #f43b3b;
  display: inline-block;
}
.arrow-up {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #62a94b;
  display: inline-block;
}
.rowStyling {
  cursor: pointer;
}
</style>